import { render } from "./KontextwechselModal.pug?vue&type=template&id=62879062&lang=pug"
import script from "./KontextwechselModal.js?vue&type=script&lang=js"
export * from "./KontextwechselModal.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__